import { Link } from 'react-router-dom';

export default function Services() {
    const services = [
        { id: 'web-design', label: 'Web Design' },
        { id: 'mobile', label: 'Mobile Application Development' },
        { id: 'IT', label: 'IT Services' },
    ];

    return (
        <ul className="space-y-4">
            {services.map(({ id, label }) => (
                <li key={id}>
                    <Link
                        to={id}
                        className="block p-4 border rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800"
                    >
                        <h3 className="text-xl font-medium">{label}</h3>
                        <p className="text-sm text-gray-600 dark:text-gray-400">
                            Learn more about our {label.toLowerCase()} services.
                        </p>
                    </Link>
                </li>
            ))}
        </ul>
    );
}
